export enum METRICGOAL {
  SEARCH = 'SEARCH',
  CATEGORISE = 'CATEGORISE',
  EVALUATE = 'EVALUATE',
  URL_PARSE = 'URL_PARSE',
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  BUG = 'BUG',
}

export class Metric {
  id: string;

  name: string;

  description: string;

  status: string;

  type: string;

  metricName: string;

  query: string;

  goal: METRICGOAL;

  values: string[];

  examples: string[];

  createdAt: string;

  updatedAt: string;

  companyId: string;

  productId: string;

  favorite?: boolean;

  isDash?: boolean;

  isFilter?: boolean;

  constructor(
    id: string,
    name: string,
    metricName: string,
    query: string,
    values: string[],
    examples: string[],
    createdAt: string,
    updatedAt: string,
    companyId: string,
    productId: string,
    isDash: boolean = false,
    isFilter: boolean = false,
    favorite: boolean = false,
    description: string = '',
    type: string = 'MANUAL' // Default type is 'MANUAL', can be changed to 'AUTOMATIC' or other types as needed
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.status = 'ACTIVE';
    this.metricName = metricName;
    this.query = query;
    this.goal = METRICGOAL.SEARCH;
    this.values = values;
    this.examples = examples;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.companyId = companyId;
    this.productId = productId;
    this.favorite = favorite;
    this.isFilter = isFilter;
    this.isDash = isDash;
    this.type = type; // Set the type of the metric
  }
}
